export default __webpack_public_path__ + "static/media/700.c089376d.png";